import React, { useState } from 'react';
import TutorialHeader from './TutorialHeader';
import { ReactComponent as TutorialImage } from '../../styles/svg-components/tutorial-model-fullbody.svg';
import { ReactComponent as TutorialImageTightFitting } from '../../styles/svg-components/tutorial-model-fullbody-tight-fitting2.svg';
import { ReactComponent as TutorialImageSetupPhone } from '../../styles/svg-components/tutorial-model-fullbody-setup-phone.svg';
import { ProgressBullets } from '../../components/ProgressBullets';
import { useHistory } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';

import './TutorialPage.scss';
import withAuth from '../../higherOrderComponents/withAuth';

export const TutorialPage = () => {
  const [wizardIndex, setWizardIndex] = useState(0);
  const history = useHistory();

  const updateIndex = (index) => {
    if (index === 3) {
      history.push('/take-photo');
    } else {
      setWizardIndex(index);
    }
  };

  return (
    <div className="full-screen">
      <TutorialHeader></TutorialHeader>

      <SwipeableViews enableMouseEvents={true} onChangeIndex={updateIndex}>
        <div className="instruction-panel">
          <TutorialImageSetupPhone className="tutorial-image"></TutorialImageSetupPhone>
          <label>Step 1: Skin tight clothers / hair</label>
        </div>
        <div className="instruction-panel">
          <TutorialImage className="tutorial-image"></TutorialImage>
          <label>Step 2: Set phone up on table </label>
          <label>Make sure you have plenty of space</label>
        </div>
        <div className="instruction-panel">
          <TutorialImageTightFitting className="tutorial-image"></TutorialImageTightFitting>
          <label>Step 3: Make sure you capture the </label>
          <label>whole body on screen</label>
        </div>
        <div className="instruction-panel">
          <label>Now take a photo</label>
        </div>
      </SwipeableViews>

      <div className="progress-wizard">
        <ProgressBullets steps={4} currentStep={wizardIndex}></ProgressBullets>
      </div>
    </div>
  );
};

export default withAuth(TutorialPage);
